import client from '../httpClient';

const registProhibitWordsApi = (params) => {
  return client.post('/prohibited-words', JSON.stringify(params));
};

export default registProhibitWordsApi;
